import client from './main-client';

export const loansApi = (params) => client().get(`/loans?userId=${params.userId}&$limit=null&active=true`);

export const addLoanApi = (data) => client().post('/loans', data);

export const updateLoanApi = (data) => client().patch(`/loans/${data._id}`, data);
